import { useSelector } from 'react-redux'
import { Notification } from '../../../common/notification'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { COMPANY_TYPES } from '../../../utils/common'
import { Layout } from '../../Layout'
import { CompanyInfo } from '../../common/header/companyInfo'
import useCheckIsCompanyType from '../../common/header/companyInfo/useCheckIsCompanyType'
import { StickyComponent } from '../common/stickyComponent'
import { BottomComponent } from './components/bottomComponent'

const CorporateRiskScore = () => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION = useSelector(selectComponentAuthorized)

  const isAllow =
    AUTHORIZATION.companyAnalysis.score[userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  const isUnavailable = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
    COMPANY_TYPES.NON_BANK,
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
  ])

  const renderStickyComponent = () => {
    return !isUnavailable && isAllow && <StickyComponent />
  }

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderStickyComponent={renderStickyComponent}
      renderBottomComponent={() =>
        isUnavailable ? (
          <Notification
            isI18n
            value="errorCommon.COMPANY_TYPE_ERROR"
            style={{ fontSize: 20 }}
          />
        ) : (
          <BottomComponent isAllow={isAllow} />
        )
      }
      isShowFooter={false}
    />
  )
}

export default CorporateRiskScore
